import { render, staticRenderFns } from "./Partants.vue?vue&type=template&id=36880c57&"
import script from "./Partants.vue?vue&type=script&lang=js&"
export * from "./Partants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports